import React from 'react';

const ClientConfigurationsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default ClientConfigurationsPage;
